// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"132":"4e08dcd8","411":"e4716bb5"}[chunkId] + ".css";
};